module.exports = __webpack_public_path__ + "img/agent-permission.106139bb.png";